module.exports = __webpack_public_path__ + "img/2.f8b0b099.jpg";